export { ComparisonPage } from './components';
